export var ClaimableTokensInstruction;
(function (ClaimableTokensInstruction) {
    ClaimableTokensInstruction[ClaimableTokensInstruction["Create"] = 0] = "Create";
    ClaimableTokensInstruction[ClaimableTokensInstruction["Transfer"] = 1] = "Transfer";
})(ClaimableTokensInstruction || (ClaimableTokensInstruction = {}));
/**
 * Custom error codes from the Claimable Tokens program
 * @see {@link https://github.com/AudiusProject/apps/blob/2a37bcff1bb1a82efdf187d1723b3457dc0dcb9b/solana-programs/claimable-tokens/program/src/error.rs solana-programs/claimable-tokens/program/src/error.rs}
 */
export var ClaimableTokensErrorCode;
(function (ClaimableTokensErrorCode) {
    ClaimableTokensErrorCode[ClaimableTokensErrorCode["SignatureVerificationFailed"] = 0] = "SignatureVerificationFailed";
    ClaimableTokensErrorCode[ClaimableTokensErrorCode["Secp256InstructionLosing"] = 1] = "Secp256InstructionLosing";
    ClaimableTokensErrorCode[ClaimableTokensErrorCode["InstructionLoadError"] = 2] = "InstructionLoadError";
    ClaimableTokensErrorCode[ClaimableTokensErrorCode["NonceVerificationError"] = 3] = "NonceVerificationError";
})(ClaimableTokensErrorCode || (ClaimableTokensErrorCode = {}));
/**
 * The UI friendly error messages for each error code.
 * @see {@link https://github.com/AudiusProject/apps/blob/2a37bcff1bb1a82efdf187d1723b3457dc0dcb9b/solana-programs/claimable-tokens/program/src/error.rs solana-programs/claimable-tokens/program/src/error.rs}
 */
export const ClaimableTokensErrorMessages = {
    [ClaimableTokensErrorCode.SignatureVerificationFailed]: 'Signature verification failed',
    [ClaimableTokensErrorCode.Secp256InstructionLosing]: 'Secp256 instruction losing',
    [ClaimableTokensErrorCode.InstructionLoadError]: 'Instruction load error',
    [ClaimableTokensErrorCode.NonceVerificationError]: 'Nonce verification failed'
};
//# sourceMappingURL=constants.js.map